export default "__VITE_ASSET__5ezhVrWK__"